import { TThunkAction } from '../../types/redux';
import { setNewAnswerFormStep } from './stepActionsTypes';
import { ENewAnswerModalStep } from '../../types/newAnswer';
import { trackNewAnswerSubmit } from '../../analytics/newAnswer';
import { addQuestionAnswer } from '../../services/questionAnswers/addQuestionAnswer';
import { TAnswerTarget } from '../../types/answers';
import { getObjectRating } from '../../selectors/objectInfo';

export function addQuestionAnswerActions({
  questionId,
  type,
}: {
  questionId: string;
  type: TAnswerTarget;
}): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    try {
      const { httpApi, custom } = context;
      const state = getState();

      await addQuestionAnswer({
        httpApi,
        parameters: { questionId, newAnswer: state.newAnswer },
      });

      const rating = getObjectRating(state);

      const page = {
        offerType: 'JK',
        pageType: 'ReviewsJK',
        siteType: custom.deviceType,
        extra: {
          question_id: questionId,
          rating,
          type: type === 'answer' ? 'answer_to_question' : type,
        },
      };

      trackNewAnswerSubmit(page);
      dispatch(setNewAnswerFormStep(ENewAnswerModalStep.Success));
    } catch (e) {
      dispatch(setNewAnswerFormStep(ENewAnswerModalStep.Error));
    }
  };
}
